import { render, staticRenderFns } from "./PastProjectCreateView.vue?vue&type=template&id=46c8f19e&"
import script from "./PastProjectCreateView.vue?vue&type=script&lang=ts&"
export * from "./PastProjectCreateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c8f19e')) {
      api.createRecord('46c8f19e', component.options)
    } else {
      api.reload('46c8f19e', component.options)
    }
    module.hot.accept("./PastProjectCreateView.vue?vue&type=template&id=46c8f19e&", function () {
      api.rerender('46c8f19e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/organization/past-project/PastProjectCreateView.vue"
export default component.exports